module.exports = __webpack_public_path__ + "img/slide_v1.e95c9e5d.png";